import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { SITE_MASTER_COLORS } from 'components/SiteMaster/SiteMaster.styles';

export const StSavedSiteCarouselSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  width: '100%',
  padding: theme.spacing(3, 3.125),
  gap: theme.spacing(2),
  backgroundColor: theme.palette.backgroundColorType3?.main || SITE_MASTER_COLORS.pageBg,
}));

export const StSavedSiteCarouselCarouselWrap = styled(Box)(() => ({
  width: '100%',
  maxWidth: '100%',
  // react-material-ui-carousel pins its slide wrapper to an inline px height measured only on navigation,
  // with slides absolutely positioned. While the active slide (framer-motion inline z-index: 1) has expanded
  // tags, that slide goes in-flow to size the wrapper; on other slides the library height applies again.
  '& > div > div:first-of-type:has([style*="z-index: 1"] [aria-expanded="true"])': {
    height: 'auto !important',
  },
  '& > div > div:first-of-type > div:has([style*="z-index: 1"] [aria-expanded="true"])': {
    position: 'relative',
  },
}));

export const StSavedSiteCarouselTitle = styled('h2')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: '100%',
  fontFamily: `${theme.palette.secondaryFontFamilyType}, 'Noto Serif', serif`,
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(36),
  lineHeight: '48px',
  textAlign: 'center',
  color: SITE_MASTER_COLORS.teal,

  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.pxToRem(28),
    lineHeight: '38px',
  },
}));

export const StSavedSiteCard = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  isolation: 'isolate',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  width: '100%',
  minHeight: 233,
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(1.5),
  height: '100%',
}));

export const StSavedSiteCardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  width: '100%',
  paddingRight: theme.spacing(4),
  zIndex: 0,
}));

export const StSavedSiteCardSiteName = styled('h3')(({ theme }) => ({
  margin: 0,
  fontFamily: theme.palette.primaryFontFamilyType,
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: theme.typography.pxToRem(18),
  lineHeight: '25px',
  color: SITE_MASTER_COLORS.textDark,
}));

export const StSavedSiteCardLocationRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
  fontFamily: theme.palette.primaryFontFamilyType,
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: '19px',
  color: SITE_MASTER_COLORS.textSecondary,
}));

export const StSavedSiteCardTagList = styled('ul')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  gap: theme.spacing(1),
  listStyle: 'none',
  margin: 0,
  padding: 0,
  width: '100%',
  zIndex: 1,
  '& .MuiButton-root.MuiButton-text.Mui-focusVisible, & .MuiButton-root.MuiButton-text:focus-visible':
    {
      outline: `2px solid ${theme.palette.common.black} !important`,
      outlineOffset: '2px',
    },
}));

export const StSavedSiteCardTag = styled('li')(({ theme }) => ({
  display: 'block',
  padding: theme.spacing(0.75, 1.5),
  borderRadius: theme.spacing(2.5),
  backgroundColor: SITE_MASTER_COLORS.chipNeutralBg,
  fontFamily: theme.palette.primaryFontFamilyType,
  fontWeight: 500,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: '19px',
  color: SITE_MASTER_COLORS.textPrimary,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,
  maxWidth: '100%',
}));

export const StSavedSiteCardButtonWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  marginTop: 'auto',
  zIndex: 2,
  '& .MuiButton-root.MuiButton-outlined.Mui-focusVisible, & .MuiButton-root.MuiButton-outlined:focus-visible':
    {
      outline: `2px solid ${theme.palette.common.black} !important`,
      outlineOffset: '2px',
    },
}));

export const StSavedSiteCardStarButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(3),
  right: theme.spacing(3),
  width: 24,
  height: 24,
  padding: 0,
  zIndex: 3,
  color: SITE_MASTER_COLORS.teal,
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.common.black}`,
    outlineOffset: '2px',
  },
}));
